import { useState } from "react";
import {
  FiPlusCircle,
  FiEdit2,
  FiTrash2,
  FiPhone,
  FiMessageCircle,
} from "react-icons/fi";


// import GridDeleteModal from "../../../components/modals/deals/GridDeleteModal";
// import EditGridModal from "../../../components/modals/deals/grid/EditGridModal";
import { Dropdown } from "react-bootstrap";
import DealsHeader from "../../../components/crm/deals/DealsHeader";
import EditDealModal from "../../../components/modals/deals/List/EditDealModal";
import DeleteDealModal from "../../../components/modals/deals/DeleteDealModal";

const columns = [
  {
    title: "New",
    color: "#8b5cf6",
    deals: [
      {
        name: "Website Redesign",
        short: "WR",
        amount: "$4,50,000",
        user: "Sharon Roy",
        percent: "85%",
        img: "/assets/img/profiles/avatar-01.jpg",
      },
      {
        name: "Cloud Backup",
        short: "CB",
        amount: "$5,00,000",
        user: "Darlee Robertson",
        percent: "15%",
        img: "/assets/img/profiles/avatar-02.jpg",
      },
    ],
  },
  {
    title: "Prospect",
    color: "#06b6d4",
    deals: [
      {
        name: "App Development",
        short: "AP",
        amount: "$3,15,000",
        user: "Jessica Louise",
        percent: "95%",
        img: "/assets/img/profiles/avatar-03.jpg",
      },
      {
        name: "SaaS Licensing",
        short: "SL",
        amount: "$6,20,000",
        user: "Rachel Hampton",
        percent: "15%",
        img: "/assets/img/profiles/avatar-04.jpg",
      },
    ],
  },
  {
    title: "Proposal",
    color: "#f59e0b",
    deals: [
      {
        name: "SEO Services",
        short: "SS",
        amount: "$8,40,000",
        user: "Jonelle Curtiss",
        percent: "60%",
        img: "/assets/img/profiles/avatar-05.jpg",
      },
      {
        name: "UX/UI Design",
        short: "UI",
        amount: "$4,50,000",
        user: "Carol Thomas",
        percent: "15%",
        img: "/assets/img/profiles/avatar-06.jpg",
      },
    ],
  },
  {
    title: "Won",
    color: "#22c55e",
    deals: [
      {
        name: "Cloud Migration",
        short: "CM",
        amount: "$2,45,000",
        user: "Jonathan Smith",
        percent: "85%",
        img: "/assets/img/profiles/avatar-07.jpg",
      },
    ],
  },
];

const DealsGrid = () => {
  const [editData, setEditData] = useState(null);
  const [deleteData, setDeleteData] = useState(null);
    const [deals, setDeals] = useState(columns);
  
 const handleDelete = () => {
    setDeals(deals.filter((d) => d.id !== deleteData.id));
    setDeleteData(null);
  };
  return (
    <div
      style={{ padding: "10px", background: "#f8f9fa" }}
      className="container-fluid "
    >
      <DealsHeader   title="DealsGrid"  />

      {/* HEADER */}
      <div className="card mb-3">
        <div className="card-body d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Deals Grid</h5>
          <Dropdown>
            <Dropdown.Toggle className="date-box text-dark">
              Sort By : Last 7 Days
              {/* <FiChevronDown size={14} /> */}
            </Dropdown.Toggle>

            <Dropdown.Menu className="custom-dropdown">
              <Dropdown.Item>Today</Dropdown.Item>
              <Dropdown.Item>Yesterday</Dropdown.Item>
              <Dropdown.Item active className="active-item">
                Last 7 Days
              </Dropdown.Item>
              <Dropdown.Item>Last 30 Days</Dropdown.Item>
              <Dropdown.Item>This Year</Dropdown.Item>
              <Dropdown.Item>Next Year</Dropdown.Item>
              <Dropdown.Item>Custom Range</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* KANBAN */}
      <div className="kanban-wrapper">
        {columns.map((col, index) => (
          <div className="kanban-column" key={index}>
            {/* COLUMN HEADER */}
            <div className="card mb-2 shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1 d-flex align-items-center fw-semibold">
                    <span
                      className="dot"
                      style={{ background: col.color }}
                    ></span>
                    {col.title}
                  </h6>
                  <small className="text-muted">30 Leads - $19,94,938</small>
                </div>

                <div className="d-flex gap-2">
                  <FiPlusCircle className="icon" />
                  <FiEdit2 className="icon" onClick={() => setEditData(col)} />
                  <FiTrash2
                    className="icon"
                    onClick={() => setDeleteData(col)}
                  />
                </div>
              </div>
            </div>

            {/* DEAL CARDS */}
            {col.deals.map((deal, i) => (
              <div className="deal-card shadow-sm" key={i}>
                <div
                  className="top-border"
                  style={{ background: col.color }}
                ></div>

                <div className="d-flex align-items-center mb-2">
                  <div className="avatar">{deal.short}</div>
                  <h6 className="mb-0">{deal.name}</h6>
                </div>

                <div className="deal-info">
                  <p>$ {deal.amount}</p>
                  <p>[email protected]</p>
                  <p>(163) 2459 315</p>
                  <p>Newyork, United States</p>
                </div>

                <div className="d-flex justify-content-between align-items-center">
                  <div className="user">
                    <div className="user">
                      <img src={deal.img} alt={deal.user} />
                      <span>{deal.user}</span>
                    </div>
                  </div>

                  <span className="badge percent-badge">{deal.percent}</span>
                </div>

                <div className="deal-footer">
                  <span>10 Jan 2024</span>
                  <div className="d-flex gap-2">
                    <FiPhone />
                    <FiMessageCircle />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* MODALS */}
      {/* <EditGridModal show={!!editData} handleClose={() => setEditData(null)} /> */}

      {/* <GridDeleteModal
        show={!!deleteData}
        handleClose={() => setDeleteData(null)}
      /> */}

      {/* MODALS */}
      <EditDealModal
        show={!!editData}
        handleClose={() => setEditData(null)}
        data={editData}
      />
      
      <DeleteDealModal
        show={!!deleteData}
        handleClose={() => setDeleteData(null)}
        onDelete={handleDelete}
      />
      {/* CSS */}
      <style>{`
        .kanban-wrapper {
          display: flex;
          gap: 16px;
          overflow-x: auto;
        }

        .kanban-column {
          min-width: 300px;
        }

        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 8px;
        }

        .deal-card {
          background: #fff;
          border-radius: 6px;
          padding: 12px;
          margin-top: 10px;
          border: 1px solid #e5e7eb;
        }

        .top-border {
          height: 4px;
          border-radius: 5px;
          margin-bottom: 10px;
        }

        .avatar {
          width: 41px;
          height: 41px;
          background: #f3f4f6;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          margin-right: 10px;
          font-weight: 500;
        }

        .deal-info p {
          margin: 0;
          font-size: 13px;
          color: #6b7280;
        }

        .user {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .user img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }

        .percent-badge {
          background: #e0f2fe;
          color: #0284c7;
          font-size: 12px;
        }

        .deal-footer {
          border-top: 1px solid #eee;
          margin-top: 10px;
          padding-top: 8px;
          display: flex;
          justify-content: space-between;
          font-size: 13px;
        }

        .icon {
          cursor: pointer;
        }
          /* Wrapper */
.date-wrapper {
  position: relative;
  width: 220px;
}

/* Input box */
.date-box {
  display: flex;
  align-items: center;
  gap: 10px;

  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
  cursor: pointer;
}

.date-box svg {
  font-size: 18px;
  color: #374151;
}

.date-box input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: #111827;
  cursor: pointer;
}

/* Dropdown */
.date-dropdown {
  position: absolute;
  top: 110%;
  left: 0;

  width: 100%;
  background: #fff;

  border: 1px solid #e5e7eb;
  border-radius: 8px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  z-index: 1000;
}

.date-box:hover,
.date-box:focus,
.date-box:active,
.date-box.show {
  background-color: #fff !important;
  color: #111827 !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}
/* Arrow top */
.date-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;

  width: 12px;
  height: 12px;
  background: white;

  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;

  transform: rotate(45deg);
}

/* Items */
.date-item {
  padding: 10px 14px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s ease;
}

/* Hover */
.date-item:hover {
  background: #f3f4f6;
}

/* Active (ORANGE) */
.date-item.active {
  background: #f97316;
  color: #fff;
}

/* Mobile */
@media (max-width: 576px) {
  .date-wrapper {
    width: 100%;
  }
}


        @media (max-width: 768px) {
          .kanban-wrapper {
            overflow-x: auto;
          }
        }
      `}</style>
    </div>
  );
};

export default DealsGrid;
